import type { RequestTypeId } from '@atlassian/jira-shared-types/src/general.tsx';
import type { FilterableIssue, MatcherCreator } from '../types.tsx';

export const requestTypeMatcherCreator: MatcherCreator<RequestTypeId[], FilterableIssue> = (
	requestTypeFilter,
) => {
	const requestTypeSet = new Set(requestTypeFilter);
	return ({ requestTypeId }) => !!requestTypeId && requestTypeSet.has(requestTypeId);
};
